import { LogLevels, consola } from 'consola';

/**
 * Create logger
 *
 * @param name - scope name
 * @returns - consola instance
 */
export function createLogger(name: string) {
  const log = consola.create({
    level: import.meta.env.PROD ? LogLevels.silent : LogLevels.debug,
  });
  return log.withTag(name);
}
